export default {
  computed: {
    openInNewWindowTitle() {
      return this.$themeLocaleConfig.openNewWindowText || '(opens new window)';
    }
  }
};